import { render, staticRenderFns } from "./DefaultListForm.vue?vue&type=template&id=cc0b1e74&lang=pug"
import script from "./DefaultListForm.vue?vue&type=script&lang=js"
export * from "./DefaultListForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports